import { useState, useEffect } from "react"
import * as tf from "@tensorflow/tfjs"
import { Database, ReportData } from "../typings"
import generateReportData from "../lib/generateReportData"

const useReportData = (
  selectedTags: string[],
  model: tf.LayersModel,
  database: Database
) => {
  const [isLoading, setIsLoading] = useState(true)
  const [reportData, setReportData] = useState<ReportData>(undefined)

  useEffect(() => {
    setIsLoading(true)

    generateReportData(selectedTags, model, database).then(reportData => {
      setReportData(reportData)
      setIsLoading(false)
    })
  }, [selectedTags])

  return {
    isLoading,
    reportData,
  }
}

export default useReportData
